import { useCallback } from "react";
import { usePathname } from "next/navigation";
import { Stack } from "@mui/material";

import { useStore } from "../../../../service/mobx";
import ButtonFilled from "../../../Button/Filled";

export default function useDialogUpgrade(cta = "Upgrade for unlimited access") {
  const { dialog } = useStore();
  const useDialogUpgrade = useCallback(() => {
    dialog.configure({
      Content: () => <Content cta={cta} />,
      headline: cta,
      sx: {
        typography: {
          m: { compact: "0", expanded: "auto" },
          pb: { compact: 0, expanded: 2 },
          mx: "auto",
          component: "h2",
          fontWeight: "500 !important",
          color: "var(--dark-primary-color)"
        },
        paper: {
          minHeight: 240,
          justifyContent: "center",
          bgcolor: "var(--dark-surface-dim)"
        }
      }
    });
  }, [dialog, cta]);

  return useDialogUpgrade;
}
function Content() {
  const pathName = usePathname();

  return (
    <Stack
      spacing={1}
      bgcolor="var(--dark-surface-container-lowest)"
      p={1}
      m="auto"
      width="100%"
      maxWidth="70%"
      justifyContent="center"
      alignItems="center"
      borderRadius="var(--shape-sm)"
    >
      <ButtonFilled
        fullWidth
        size="large"
        label="Upgrade to Pay-as-you-go"
        href={`/api/pricing?returnTo=${pathName}`}
        sx={{ borderRadius: "var(--shape-sm)" }}
      />
    </Stack>
  );
}
